'use client';
import styled, { css } from 'styled-components';

const stretchLinkAndButton = css`
  & a {
    display: block;
    width: 100%;
  }

  & button {
    width: 100%;
  }
`;

/**
 * 20px left/right inset when sideMargin is on with full-width
 */
const sideMarginInsets = css`
  padding-left: ${props => props.theme.spacing(5)};
  padding-right: ${props => props.theme.spacing(5)};
`;

const fullWidthStyles = css`
  ${stretchLinkAndButton}
  ${props => props.$sideMargin && sideMarginInsets}
`;

export const StyledCtaButton = styled.div`
  display: flex;
  box-sizing: border-box;
  width: 100%;
  max-width: 100%;
  justify-content: ${props => props.theme.getJustifyContent(props.$alignment)};

  & button {
    height: 56px;
  }

  ${props =>
    props.$fullWidth || props.$fullWidthMobile
      ? fullWidthStyles
      : css`
          & a {
            display: inline;
            width: auto;
          }

          & button {
            width: auto;
          }
        `}

  @media ${props => props.theme.tablet} {
    ${props =>
      props.$fullWidth || props.$fullWidthDesktop
        ? fullWidthStyles
        : css`
            padding-left: 0;
            padding-right: 0;

            & a {
              display: inline;
              width: auto;
            }

            & button {
              width: auto;
            }
          `}
  }
`;

export const CtaImageContainer = styled.span`
  display: inline-flex;
  flex-shrink: 0;
  align-items: center;
  width: 20px;
  height: 20px;
  overflow: hidden;
  margin-right: ${props =>
    props.$position === 'left' ? props.theme.spacing(2) : '0'};
  margin-left: ${props =>
    props.$position === 'right' ? props.theme.spacing(2) : '0'};

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`;
